import * as angular from "angular";

angular
  .module('bringoz.admin.payments', [
    'bringoz.admin.commons'
  ]);
